export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const validatePhone = (phone) => {
  const re = /^[0-9+\-\s()]+$/;
  return phone && re.test(phone) && phone.trim().length >= 10;
};

export const validatePassword = (password) => {
  return password && password.length >= 6;
};

export const validateName = (name) => {
  return name && name.trim().length >= 2;
};

export const validateExperience = (experience) => {
  return experience >= 0 && experience <= 50;
};

export const validateRequired = (value) => {
  return value && value.trim().length > 0;
};